/* eslint-disable jsx-a11y/iframe-has-title */
import Banner from '../../sections/common/banner';
import { data } from '../../../globals/data/contact-us';
import { publicUrlFor } from '../../../globals/constants';
import ContactPageHelmet from '../../helmets/ContactPageHelmet';
import { toast } from 'react-toastify';

export default function ContactPage() {
	return (
		<>
			<ContactPageHelmet />
			<Banner _data={data.banner} />

			<div className='section-full  p-t120 p-b120'>
				<div className='section-content'>
					<div className='container'>
						<div className='gmap-outline mb-5 pb-5'>
							<div className='google-map'>
								<iframe
									src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3607.907077740977!2d55.29505058826144!3d25.273711120064384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f4344fae42e69%3A0x7f6eb8d7069da995!2sGold%20Land%20Building%20-%20Deira%20-%20Al%20Sabkha%20-%20Dubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2s!4v1755665452526!5m2!1sen!2s'
									width='600'
									height='500'
									style={{ border: 0 }}
									allowfullscreen=''
									loading='lazy'
									referrerpolicy='no-referrer-when-downgrade'
								/>
							</div>
						</div>
						<div className='contact-one'>
							{/* TITLE START*/}
							<div className='section-head left wt-small-separator-outer'>
								<h3 className='wt-title mb-3'>Send Us a Message</h3>
							</div>
							{/* TITLE END*/}
							{/* CONTACT FORM*/}
							<div className='contact-one-inner  site-bg-sky-blue-light'>
								<div className='row'>
									<div className='col-lg-7 col-md-12'>
										<div className='contact-form-outer'>
											<form
												className='cons-contact-form'
												method='post'
												action='form-handler2.php'
												id='booking-form'
											>
												<div className='row'>
													<div className='col-lg-6 col-md-6'>
														<div className='form-group mb-3'>
															<input
																name='username'
																type='text'
																required
																className='form-control'
																placeholder='Name'
															/>
														</div>
													</div>
													<div className='col-lg-6 col-md-12'>
														<div className='form-group mb-3'>
															<input
																name='email'
																type='text'
																className='form-control'
																required
																placeholder='Email'
															/>
														</div>
													</div>
													<div className='col-lg-6 col-md-12'>
														<div className='form-group mb-3'>
															<input
																name='phone'
																type='text'
																className='form-control'
																required
																placeholder='Phone'
															/>
														</div>
													</div>
													<div className='col-lg-6 col-md-12'>
														<div className='form-group mb-3'>
															<input
																name='subject'
																type='text'
																className='form-control'
																required
																placeholder='Subject'
															/>
														</div>
													</div>
													<div className='col-lg-12'>
														<div className='form-group mb-3'>
															<textarea
																name='message'
																className='form-control'
																rows={3}
																placeholder='Message'
																defaultValue={''}
															/>
														</div>
													</div>
													<div className='col-md-12'>
														<button
															type='button'
															className='btn-half site-button'
															onClick={() => {
																const id = toast.loading('Loading...');
																setTimeout(() => {
																	toast.update(id, {
																		render:
																			"Submitted successfully. We'll reach out to you soon!",
																		type: 'success',
																		isLoading: false,
																		autoClose: 3000,
																		closeOnClick: true,
																	});
																	document
																		.getElementById('booking-form')
																		.reset();
																}, 2000);
																// reset the form
															}}
														>
															<span>Submit Now</span>
															<em></em>
														</button>
													</div>
												</div>
											</form>
										</div>
									</div>
									<div className='col-lg-5 col-md-12'>
										<div
											className='contact-info  site-bg-dark bg-no-repeat bg-bottom-left h-100'
											style={{
												backgroundImage: `url(${publicUrlFor(
													'/assets/images/background/contact-bg.png',
												)})`,
											}}
										>
											{/* TITLE START*/}
											<div className='section-head-small white mb-4'>
												<h3 className='wt-title'>Let's get in touch</h3>
											</div>
											{/* TITLE END*/}
											<div className='contact-info-section'>
												<div className='c-info-column'>
													<div className='c-info-icon fa fa-map-marker'>
														<span />
													</div>
													<p>
														<b>Head Office: </b>
														1st Floor Office No 105 Gold Land
														Building Dubai, UAE
													</p>
												</div>
												<div className='c-info-column'>
													<div className='c-info-icon fa fa-map-marker'>
														<span />
													</div>
													<p>
														<b>India Office: </b> Ground Floor 26, Indra Prakash
														Building, 21, Barakhamba Rd, Connaught Place, New
														Delhi, Delhi 110001, India
													</p>
												</div>
												<div className='c-info-column'>
													<div className='c-info-icon fa fa-map-marker'>
														<span />
													</div>
													<p>
														<b>Turkey Office: </b> Mesih Pasa, Aksaray Cd. No:32
														D:56, 34130 Fatih/Istanbul, Turkey
													</p>
												</div>

												<div className='c-info-column'>
													<div className='c-info-icon fa fa-envelope-o'>
														<span />
													</div>
													<p>info@velocentglobal.com</p>
													<p>support@velocentglobal.com</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
